'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// In part adapted from https://github.com/jasonsalzman/react-add-to-calendar
/* global window */
function formatTime(date) {
  var formattedDate = _moment2.default.utc(date).format('YYYYMMDDTHHmmssZ');
  return formattedDate.replace('+00:00', 'Z');
}

function calculateDuration(startTime, endTime) {
  // snag parameters and format properly in UTC
  var end = _moment2.default.utc(endTime).format('DD/MM/YYYY HH:mm:ss');
  var start = _moment2.default.utc(startTime).format('DD/MM/YYYY HH:mm:ss');

  // calculate the difference in milliseconds between the start and end times
  var difference = (0, _moment2.default)(end, 'DD/MM/YYYY HH:mm:ss').diff((0, _moment2.default)(start, 'DD/MM/YYYY HH:mm:ss'));

  // convert difference from above to a proper momentJs duration object
  var duration = _moment2.default.duration(difference);

  return Math.floor(duration.asHours()) + _moment2.default.utc(difference).format(':mm');
}

function buildIcalLocation(venue) {
  return venue.name + ' (' + venue.address + ', ' + venue.city + ' ' + venue.zip + ')';
}

function buildShareUrl(event, type) {
  var match = event.url.match(/(?:https?:\/\/|)([^/]+).*/);
  var domain = match[1];
  var duration = calculateDuration(event.start_date, event.end_date);

  var calendarUrl = '';

  switch (type) {
    case 'twitter':
      calendarUrl = 'https://twitter.com/home?status=' + event.url;
      break;

    case 'facebook':
      calendarUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + event.url;
      break;

    case 'linkedIn':
      calendarUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=' + event.url + '&title=' + encodeURIComponent(event.title);
      break;

    case 'google':
      calendarUrl = 'https://calendar.google.com/calendar/render';
      calendarUrl += '?action=TEMPLATE';
      calendarUrl += '&dates=' + formatTime(event.start_date);
      calendarUrl += '/' + formatTime(event.end_date);
      calendarUrl += '&location=' + encodeURIComponent(buildIcalLocation(event.venue));
      calendarUrl += '&text=' + encodeURIComponent(event.title);
      calendarUrl += '&details=' + encodeURIComponent(event.description);
      break;

    case 'outlookcom':
      calendarUrl = 'https://outlook.live.com/owa/?rru=addevent';
      calendarUrl += '&startdt=' + formatTime(event.start_date);
      calendarUrl += '&enddt=' + formatTime(event.end_date);
      calendarUrl += '&subject=' + encodeURIComponent(event.title);
      calendarUrl += '&location=' + encodeURIComponent(buildIcalLocation(event.venue));
      calendarUrl += '&body=' + encodeURIComponent(event.description);
      calendarUrl += '&allday=false';
      calendarUrl += '&uid=' + event.id + '@' + domain;
      calendarUrl += '&path=/calendar/view/Month';
      break;

    case 'yahoo':
      calendarUrl = 'https://calendar.yahoo.com/?v=60&view=d&type=20';
      calendarUrl += '&title=' + encodeURIComponent(event.title);
      calendarUrl += '&st=' + formatTime(event.start_date);
      calendarUrl += '&dur=' + duration;
      calendarUrl += '&desc=' + encodeURIComponent(event.description);
      calendarUrl += '&in_loc=' + encodeURIComponent(buildIcalLocation(event.venue));
      break;

    default:
      calendarUrl = '//' + domain + '/api/events/' + event.id + '.ics';
  }

  return calendarUrl;
}

function handlePrint(ev) {
  window.print();
  ev.preventDefault();
  return false;
}

function handleKeyPress(event) {
  if (event.key === 'Enter') {
    handlePrint();
  }
}

var ShareLinks = function ShareLinks(_ref) {
  var event = _ref.event,
      icons = _ref.icons,
      noTint = _ref.noTint;

  if (event.url === undefined) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'ShareLinks ' + (noTint && 'noTint') },
    _react2.default.createElement(
      'ul',
      null,
      icons.map(function (icon) {
        switch (icon) {
          case 'ical':
            return _react2.default.createElement(
              'li',
              { key: icon },
              _react2.default.createElement(
                'a',
                { target: '_blank', rel: 'noopener noreferrer', href: buildShareUrl(event, 'ical') },
                'iCal'
              )
            );
          case 'print':
            return _react2.default.createElement(
              'li',
              { key: icon },
              _react2.default.createElement(
                'span',
                { onClick: handlePrint, onKeyPress: handleKeyPress },
                _react2.default.createElement(_Icon2.default, { name: 'printer' })
              )
            );
          default:
            return _react2.default.createElement(
              'li',
              { key: icon },
              _react2.default.createElement(
                'a',
                { href: buildShareUrl(event, icon), target: '_blank', rel: 'noopener noreferrer' },
                _react2.default.createElement(_Icon2.default, { name: icon })
              )
            );
        }
      })
    )
  );
};

ShareLinks.propTypes = {
  /** The event to export. */
  event: _propTypes2.default.object.isRequired,
  /** A list of icons to display. twitter, facebook, linkedIn, google, yahoo, ical, print */
  icons: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /** Whether icons should be tinted with the primary color */
  noTint: _propTypes2.default.bool
};

ShareLinks.defaultProps = {
  icons: ['twitter', 'facebook', 'google', 'yahoo', 'ical', 'print'],
  noTint: false
};

exports.default = ShareLinks;
ShareLinks.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'ShareLinks',
  'props': {
    'icons': {
      'defaultValue': {
        'value': '[\'twitter\', \'facebook\', \'google\', \'yahoo\', \'ical\', \'print\']',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'string'
        }
      },
      'required': false,
      'description': 'A list of icons to display. twitter, facebook, linkedIn, google, yahoo, ical, print'
    },
    'noTint': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether icons should be tinted with the primary color'
    },
    'event': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'The event to export.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/ShareLinks.js
// module id = 190
// module chunks = 0